"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserPermissionsSwaggerMetadata = getUserPermissionsSwaggerMetadata;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
function getUserPermissionsSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get User Permissions",
        description: "Retrieves the permissions for a specific user based on their roles and access control mappings.",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Permissions retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Permissions retrieved successfully.",
                },
                data: {
                    type: "object",
                    properties: {
                        roleId: { type: "number", example: 1 },
                        roleName: { type: "string", example: "Admin" },
                        access: {
                            type: "object",
                            additionalProperties: {
                                type: "object",
                                properties: {
                                    read: { type: "boolean", example: true },
                                    write: { type: "boolean", example: false },
                                },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 401,
        description: "Unauthorized. Invalid or expired token.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 401 },
                message: { type: "string", example: "Invalid or expired token." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
